import { Pipe, PipeTransform, Inject } from '@angular/core';
import { _, TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'guestAccessStatus'
})
export class GuestAccessStatusPipe implements PipeTransform {
  private labels: string[] = [];
  constructor(@Inject(TranslateService) private translate: TranslateService) { 
    this.labels = [
      this.translate.instant(_('dashboard.guests_not_arrived_yet')),
      this.translate.instant(_('dashboard.guest_arrived')),
      this.translate.instant(_('dashboard.guest_rejected_but_here')),
    ];
  }

  transform(value: number, args?: any): any {
    return this.labels[value];
  }

}
